import React from 'react';
import { TableAppBody } from 'components/IterioApp/components/TableApp';
import UserTableCell from '../UserTableCell';

const UserTableBody = ({ users, selectedUsers, handleSelectUser, handleSelectUsers }) => {
  return (
    <TableAppBody>
      {users.map(user => (
        <UserTableCell
          key={`${user.id}${user.user_id}`}
          user={user}
          selectedUsers={selectedUsers}
          handleSelectUser={handleSelectUser}
          handleSelectUsers={handleSelectUsers}
        />
      ))}
    </TableAppBody>
  );
};

export default UserTableBody;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/UserTableBody/UserTableBody.js